import React from 'react'
import { Stack } from 'react-bootstrap'
import { getFormattedDuration } from '../../../../common/duration'

export interface MeetingDurationDisplayProps {
  startedAt: string
  finishedAt?: string
}
export const MeetingDurationDisplay: React.FC<MeetingDurationDisplayProps> = ({ startedAt, finishedAt }) => {
  return (
    <Stack direction='horizontal' gap={2}>
      <i className='bi bi-clock-fill icon' />
      <span className='paragraph-small'>{getFormattedDuration(startedAt, finishedAt)}</span>
    </Stack>
  )
}
